import { StateUtils } from '@spartacus/core';
import { MiniShoppingListSearchResult } from '../../../model';
import { UserActions } from '../actions';
import { ShoppingListActionTypes } from '../actions/shopping-list.action';

export const initialState: any = {
  lastUpdateTime: undefined,
  results: [],
};

export function reducer<T>(state: T = initialState, action: UserActions.ShoppingListActions | StateUtils.LoaderAction): T {
  switch (action.type) {
    case ShoppingListActionTypes.SearchMiniShoppingListsSuccess: {
      const _action = <UserActions.SearchMiniShoppingListsSuccess>action;
      const payload: MiniShoppingListSearchResult = _action.payload.searchResult;
      const results = payload.results.map((r) => r.code);

      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
        results,
      };
    }
    case ShoppingListActionTypes.SearchMiniShoppingListsFail: {
      return {
        ...state,
        lastUpdateTime: new Date().toISOString(),
      };
    }
  }

  return state;
}
